export default __webpack_public_path__ + "static/media/EBikeBlack1.7cbc5a04.png";